import { useEffect, useState, useContext } from 'react';
import { history } from 'umi';
import { useIntl } from 'react-intl';
import { PlusOutlined, CreditCardOutlined } from 'iglooicon';
import Context from '@/utils/context';
import { Typography } from 'iglooform';
import { getAccounts } from '../service';
import './receiving-account.less';
import SkeletonLoading from '@/components/skeleton-loading';
import { BackButton } from '@/components/back-button/back-button';

const ReceivingAccountPage = () => {
  const { formatMessage } = useIntl();
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { isPc } = useContext(Context);
  useEffect(() => {
    getAccounts().then((res) => {
      setAccounts(res.accounts);
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    getAccounts()
      .then((res) => {
        if (res.accounts.length) {
          setAccounts(res.accounts);
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      {!loading ? (
        <div className="account-container">
          <BackButton handleClick={() => history.push('/home')} />
          <div className="account-form">
            {!!accounts.length &&
              accounts.map((account) => {
                const hideNumberLengthStar = '*'.repeat(
                  account.account_number.length - 4,
                );
                return (
                  <section
                    key={account.account_id}
                    className="account-card"
                    style={
                      isPc
                        ? { display: 'block', marginTop: '50px' }
                        : { display: 'block', marginTop: 24 }
                    }
                  >
                    <section className="curr-account">
                      <section className="holder-name">
                        <CreditCardOutlined
                          className="icon"
                          style={{
                            marginRight: '8px',
                            fontSize: 24,
                            color: '#5858FF',
                          }}
                        />
                        <Typography level="h4">
                          {account.holder_name}
                        </Typography>
                      </section>
                      <section className="account-number">
                        <Typography level="h2">
                          {hideNumberLengthStar +
                            account.account_number?.substring(
                              account.account_number.length - 4,
                            )}
                        </Typography>
                      </section>
                    </section>
                  </section>
                );
              })}
            <section
              className="account-card"
              style={{
                marginTop: '24px',
                flexDirection: 'row',
                cursor: 'pointer',
                height: '56px',
                padding: '16px',
              }}
              onClick={() =>
                history.push('/me/verify-payment-password/change-account')
              }
            >
              <div style={{ color: '#5858FF' }}>
                <PlusOutlined
                  style={{
                    fontSize: '24px',
                    marginRight: '4px',
                    display: 'block',
                    float: 'left',
                  }}
                />
                <Typography
                  level="body1"
                  style={{ display: 'block', float: 'left', marginTop: '2px' }}
                >
                  {accounts.length
                    ? formatMessage({ id: 'Change Account' })
                    : formatMessage({ id: 'Add Account' })}
                </Typography>
              </div>
            </section>
          </div>
        </div>
      ) : (
        <div style={{ marginTop: '45px' }}>
          <SkeletonLoading />
        </div>
      )}
    </>
  );
};

export default ReceivingAccountPage;
